import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { useApplicationHistoryFilters } from 'automation-ui-management/hooks/filterHooks';
import { getTimestampsFromHistoryFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MessageComponent = ({
  title,
  tooltipContent
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    className: "m-bottom-2",
    justify: "center",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "small",
      use: "help",
      marginBlockStart: "50",
      children: title
    }), /*#__PURE__*/_jsx(UITooltip, {
      title: tooltipContent,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        size: 12,
        color: EERIE,
        className: "m-left-1"
      })
    })]
  });
};
const EnrollmentConversionMessage = ({
  enrollmentConversionData,
  reportingStatusLastUpdated
}) => {
  var _enrollmentConversion;
  const {
    filters
  } = useApplicationHistoryFilters();
  const timeStamps = getTimestampsFromHistoryFilters(filters);
  if ((enrollmentConversionData === null || enrollmentConversionData === void 0 || (_enrollmentConversion = enrollmentConversionData.conversionReport) === null || _enrollmentConversion === void 0 ? void 0 : _enrollmentConversion.totalEnrollmentCount) > 0) {
    if (timeStamps !== null && timeStamps !== void 0 && timeStamps.startTimestamp && (timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp) < reportingStatusLastUpdated) {
      return /*#__PURE__*/_jsx(MessageComponent, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.messages.metricsAvailableWithSubsetOfEnrollments.text"
        }),
        tooltipContent: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation.enrollmentConversion.messages.metricsAvailableWithSubsetOfEnrollments.tooltip",
          options: {
            metricsEnabledTime: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
              value: reportingStatusLastUpdated,
              format: `llll z`
            })
          }
        })
      });
    } else {
      return /*#__PURE__*/_jsx(MessageComponent, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.messages.metricsAvailable.text"
        }),
        tooltipContent: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.messages.metricsAvailable.tooltip"
        })
      });
    }
  } else {
    if (timeStamps !== null && timeStamps !== void 0 && timeStamps.startTimestamp && (timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp) < reportingStatusLastUpdated) {
      return /*#__PURE__*/_jsx(MessageComponent, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.messages.metricsNotAvailable.text"
        }),
        tooltipContent: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.messages.metricsNotAvailable.tooltip"
          }), /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
            value: reportingStatusLastUpdated,
            format: `llll z`
          })]
        })
      });
    }
  }
  return null;
};
export default EnrollmentConversionMessage;